"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBusinessMemberRequestToJSON = exports.UpdateBusinessMemberRequestFromJSONTyped = exports.UpdateBusinessMemberRequestFromJSON = exports.instanceOfUpdateBusinessMemberRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateBusinessMemberRequest interface.
 */
function instanceOfUpdateBusinessMemberRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateBusinessMemberRequest = instanceOfUpdateBusinessMemberRequest;
function UpdateBusinessMemberRequestFromJSON(json) {
    return UpdateBusinessMemberRequestFromJSONTyped(json, false);
}
exports.UpdateBusinessMemberRequestFromJSON = UpdateBusinessMemberRequestFromJSON;
function UpdateBusinessMemberRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'emailAddress': !(0, runtime_1.exists)(json, 'email_address') ? undefined : json['email_address'],
        'hasMarketingOptIn': !(0, runtime_1.exists)(json, 'has_marketing_opt_in') ? undefined : json['has_marketing_opt_in'],
    };
}
exports.UpdateBusinessMemberRequestFromJSONTyped = UpdateBusinessMemberRequestFromJSONTyped;
function UpdateBusinessMemberRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'email_address': value.emailAddress,
        'has_marketing_opt_in': value.hasMarketingOptIn,
    };
}
exports.UpdateBusinessMemberRequestToJSON = UpdateBusinessMemberRequestToJSON;
